const selectors = {
  fields: 'input:not([type="checkbox"]):not([type="hidden"]), textarea',
  fieldEmail: 'input[type="email"]',
  fieldDate: 'input[type="date"]',
  fieldTextarea: 'textarea',
  fieldText: 'input.properties__input--sender-name',
  fieldTextareaInfo: '.recipient-fields__field-textarea--info span',
  fieldTextInfo: '.recipient-fields__field-text--info span',
  formWrapper: '[data-form-wrapper]',
  addToCartButton: '[data-add-to-cart]',
  popupComponent: 'popup-component',
};

if (!customElements.get('recipient-form')) {
  customElements.define(
    'recipient-form',
    class RecipientForm extends HTMLElement {
      constructor() {
        super();
        this.fieldEmail = this.querySelector(selectors.fieldEmail);
        this.fieldDate = this.querySelector(selectors.fieldDate);
        this.fieldTextarea = this.querySelector(selectors.fieldTextarea);
        this.fieldText = this.querySelector(selectors.fieldText);
        this.fields = this.querySelectorAll(selectors.fields);
        this.formWrapper = this.closest(selectors.formWrapper);
        this.form = this.formWrapper?.querySelector('form[data-product-form]') || null;
        this.formSubmitButton = this.formWrapper?.querySelector(selectors.addToCartButton) || null;

        this.onFieldTextareaChangeEvent = (event) => this.onFieldTextareaChange(event);
        this.onFieldTextChangeEvent = (event) => this.onFieldTextChange(event);
        this.toggleButtonState = this.toggleButtonState.bind(this);
        this.onSubmit = this.onSubmit.bind(this);

        this.popupComponent = this.closest(selectors.popupComponent);
      }

      connectedCallback() {
        if (this.formWrapper) {
          if (this.fieldTextarea) {
            this.fieldTextarea.addEventListener('input', this.onFieldTextareaChangeEvent);
          }

          if (this.fieldText) {
            this.fieldText.addEventListener('input', this.onFieldTextChangeEvent);
          }

          this.form.addEventListener('submit', (e) => {
            if (!this.fieldEmail || !this.fieldEmail.checkValidity()) {
              e.preventDefault();
              console.log('fieldEmail.checkValidity()', this.fieldEmail?.checkValidity());
              return;
            }
          });

          this.formWrapper.addEventListener('theme:product:add', () => {
            // this.clearInputValues();
            this.popupCloseByEvent();
          });

          if (this.popupComponent) {
            this.popupComponent.addEventListener('popup:open', (e) => {
              this.initDatepicker();
              this.toggleButtonState();
            });
          }

          if (this.form) {
            this.form.addEventListener('input', this.toggleButtonState);
            this.form.addEventListener('change', this.toggleButtonState);
            this.form.addEventListener('submit', this.onSubmit);
          }
        }
      }

      initDatepicker() {
        const el = this.querySelector('#DatePicker');
        if (!el || el._flatpickr) return;

        const _this = this;

        flatpickr(el, {
          inline: true,
          defaultDate: new Date().fp_incr(1),
          minDate: new Date().fp_incr(1),
          maxDate: new Date().fp_incr(90),
          dateFormat: "Y-m-d",
          // disable: [date => date.getDay() === 0 || date.getDay() === 6],
          locale: { firstDayOfWeek: 0 },
          monthSelectorType: "static",
          prevArrow: '<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none"><path d="M12.5 5L7.5 10L12.5 15" stroke="currentColor" stroke-width="1.66667" stroke-linecap="round" stroke-linejoin="round"/></svg>',
          nextArrow: '<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none"><path d="M7.5 15L12.5 10L7.5 5" stroke="currentColor" stroke-width="1.66667" stroke-linecap="round" stroke-linejoin="round"/></svg>',
          onChange: function(selectedDates, dateStr) {
            _this.onDateChange(dateStr);
          },
          onReady: function() {}
        });
      }

      onSubmit(e) {
        if (!this.form.reportValidity()) {
          e.preventDefault();
          return;
        }
      }

      toggleButtonState() {
        // const isValid = typeof this.form.checkValidity === 'function' ? this.form.checkValidity() : false;
        const isValid = this.form.checkValidity();

        if (this.formSubmitButton) {
          this.formSubmitButton.disabled = !isValid;
        }
      }

      onDateChange (date) {
        if (!date) return;

        this.fieldDate.value = date;
      }

      popupCloseByEvent() {
        if (this.popupComponent) this.popupComponent.popupClose();
      }

      clearInputValues() {
        if (this.fields.length) {
          this.fields.forEach((field) => {
            field.value = '';
          });
        }
      }

      onFieldTextareaChange(event) {
        if (this.querySelector(selectors.fieldTextareaInfo)) this.querySelector(selectors.fieldTextareaInfo).textContent = event.target.value.length;
      }

      onFieldTextChange(event) {
        if (this.querySelector(selectors.fieldTextInfo)) this.querySelector(selectors.fieldTextInfo).textContent = event.target.value.length;
      }

      onChange(event) {
        if (!event.target.checked) {
          this.clearInputValues();
        }
      }

      disconnectedCallback() {
        if (this.fieldTextarea) this.fieldTextarea.removeEventListener('input', this.onFieldTextareaChangeEvent);
        if (this.fieldText) this.fieldText.removeEventListener('input', this.onFieldTextChangeEvent);
      }
    }
  );
}